module.exports = __webpack_public_path__ + "img/4.592e63fc.jpg";